import React from 'react';

var ResponsiveContext = React.createContext(null);

export { ResponsiveContext };
